import { TsButtonModule } from 'tsui';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Overlay } from '@angular/cdk/overlay';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from 'app/shared/shared.module';
import { SearchComponent } from 'app/layout/common/search/search.component';
import { ResultItemComponent } from './result-item/result-item.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HighlighterPipe } from '@shared/pipes/highlighter.pipe';

@NgModule({
  declarations: [SearchComponent, ResultItemComponent],
  imports: [
    TsButtonModule,
    RouterModule.forChild([]),
    MatAutocompleteModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    SharedModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    HighlighterPipe,
  ],
  exports: [SearchComponent, ResultItemComponent],
  providers: [
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => {
        return () => overlay.scrollStrategies.block();
      },
      deps: [Overlay],
    },
  ],
})
export class SearchModule {}
